<template>
  <v-container>
    <v-row dense>
      <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
        <v-row class="px-4 pt-4">
          <v-col md="4" sm="6" xs="6" cols="6" class="my-0 py-0">
            <v-autocomplete
                prepend-icon="mdi-account"
                v-model="clientid"
                item-text="text"
                label="Filter by a client ..."
                @change="getList()"
                :items="clients"
            />
          </v-col>
          <v-col md="4" sm="6" xs="6" cols="6" class="my-0 py-0">
            <v-select
                prepend-icon="mdi-text-box-multiple-outline"
                v-model="invoicetype"
                item-text="text"
                @change="getList()"
                label="Filter by invoice type"
                :items="invoices"
            />
          </v-col>
          <v-col md="4" sm="6" xs="6" cols="6" class="my-0 py-0">
            <v-select
                prepend-icon="mdi-file-table-box-multiple"
                v-model="ordertype"
                item-text="text"
                @change="getList()"
                label="Filter by platform"
                :items="platforms"
            />
          </v-col>
          <v-col md="4" sm="6" xs="6" cols="6" class="my-0 py-0">
            <v-select
                prepend-icon="mdi-account-tie"
                v-model="user"
                item-text="text"
                @change="getUsers()"
                label="Filter by employee"
                :items="users"
            />
          </v-col>
          <v-col md="4" sm="6" xs="6" cols="6" class="my-0 py-0">
            <v-text-field
                prepend-icon="mdi-pencil"
                v-model="notes"
                label="Filter by notes"
            />
          </v-col>
          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-dialog ref="dialog" v-model="modal" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateRangeText"
                    label="Date range"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false"
                >Cancel</v-btn
                >
                <v-btn
                    text
                    color="primary"
                    @click="
                    $refs.dialog.save(date);
                    getList();
                  "
                >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col>
            <v-btn @click="submit" dark color="indigo">
              <v-icon class="mr-1">mdi-chart-box-outline</v-icon> Show report
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
    <v-row v-if="showTable">
      <v-col cols="12">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>#</th>
            <th>Client</th>
            <th>Date</th>
            <th>Employee</th>
            <th>Total</th>
            <th>Cost</th>
            <th>Profit</th>
            <th>Platform</th>
            <th>Type</th>
            <th>Notes</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              :key="item.id"
          >
            <td>{{ item.id }}</td>
            <td>{{ item.clientname }}</td>
            <td>{{ item.adddate }}</td>
            <td>{{ item.addby }}</td>
            <td>{{ item.grandtotal }}</td>
            <td>{{ item.cost }}</td>
            <td>{{ item.profit }}</td>
            <td>{{ item.ordertype }}</td>
            <td>{{ item.invoicetype }}</td>
            <td>{{ item.notes }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-if="showTable" class="mb-6">
      <v-col cols="6" class="text-center lightgrey">
        Number of invoices:  <strong> {{ items.length }} </strong>
      </v-col>
      <v-col cols="6" class="text-center lightgrey">
        Total Sales Amount:  <strong> $ {{ totalsales }} </strong>
      </v-col>
      <v-col cols="6" class="text-center lightgrey">
        Total Cost Amount:  <strong> $ {{ totalcost }} </strong>
      </v-col>
      <v-col cols="6" class="text-center lightgrey">
        Total Profit Amount:  <strong> $ {{ totalprofit }} </strong>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import { __HTTP, FormHeader } from "@/utils/utils";

export default {
  name: "SalesReport",
  computed: {
    dateRangeText() {
      //this.getList();
      return this.dates.join(" ~ ");
    },
    totalprofit() {
      var total = 0;
      this.items.forEach(e => {
        //console.log(e);
        total += parseInt(e.profit.replace(",",""));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    totalsales() {
      var total = 0;
      this.items.forEach(e => {
        total += parseInt(e.grandtotal.replace(",",""));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    totalcost() {
      var total = 0;
      this.items.forEach(e => {
        total += parseInt(e.cost);
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
  },

  methods: {

    getList() {
      this.isloading = true;
      this.items = [];
     //console.log(this.user);
      //console.log(JSON.stringify({keyword: this.search,clientid: this.clientid,ordertype: this.ordertype,date: this.dates}));
      __HTTP(
          "?do=list&type=sales",
          JSON.stringify({
             pageNumber: 0,
          itemsPerPage: -1,
            keyword: this.search,
            clientid: this.clientid,
            ordertype: this.ordertype,
            userid: this.user,
            invoicetype: this.invoicetype,
            date: this.dates,
            isadmin: this.$store.state.loggedUser.isadmin,
          }),
          FormHeader,
          res => {
           // console.log(res);
            this.isloading = false;
            this.items = res.data;
          }
      );
    },
    getClients() {
      this.loading = true;
      __HTTP("?do=getclients", "", FormHeader, res => {
        this.getPlatforms();
        this.isloading = false;
        this.clients = res;
      });
    },
    getUsers() {
      this.loading = true;
      __HTTP("?do=getusers", "", FormHeader, res => {
        this.isloading = false;
        this.users = res;
      });
    },
    getPlatforms() {
      __HTTP("?do=getplatforms", "", FormHeader, res => {
        //this.isloading = false
        this.platforms = res;
      });
    },
    submit() {
      this.getList();
      this.showTable = true
    }


  },
  mounted() {
    this.$store.state.title = "Sales Report";
    this.dates = [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1 + 1)
          .toISOString()
          .substr(0, 10),
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0 + 1)
          .toISOString()
          .substr(0, 10)
    ];
  },
  created() {
    this.$store.state.title = "Sales";
    this.getUsers();
    this.getClients();
    //this.getList();
  },
  components: {},
  data: () => ({
    search: "",
    platforms: [],
    clientid: null,
    isloading: false,
    showTable: false,
    
    modal: false,
    count: 0,
    
    loadingtext: "Please wait while loading data ...",
    clients: [],
    users: [],
    items: [],
    notes:"",
    user:[],
    invoicetype: [],
    invoices: [
      { text: "Custom PC", value: "0" },
      { text: "Parts", value: "1" }
    ],
    ordertype: [],
    //today: new Date(),
    dates: [],
  })
};
</script>
